/**
 * Returns the store's GST number, or "" when the store has none configured.
 * Backend saves it under gstData.gstNumber; older shapes are kept as fallbacks.
 */
export const getStoreGstNumber = (store) => {
    if (!store || typeof store !== "object") return "";
    const value = store.gstData?.gstNumber || store.gstData?.gstNo || store.gstNumber || "";
    return typeof value === "string" ? value.trim() : "";
};

/** Picks the GST number from the invoice's store first, then the currently selected store. */
export const getInvoiceStoreGstNumber = (invoice, currentStore) =>
    getStoreGstNumber(invoice?.storeId) || getStoreGstNumber(currentStore);
